import { render } from "./FormSchedule.vue?vue&type=template&id=2ffe4cfe&scoped=true"
import script from "./FormSchedule.vue?vue&type=script&lang=js"
export * from "./FormSchedule.vue?vue&type=script&lang=js"

import "./FormSchedule.vue?vue&type=style&index=0&id=2ffe4cfe&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffe4cfe"]])

export default __exports__